import client from "api/client";


const _client = client.route("/card");

const card = {
	setup: (payload) => _client.post("/setup", payload),
	all: (payload) => _client.post("/all", payload),
	add: (payload) => _client.post("", payload),
	updateDefault: (payload) => _client.post("/default", payload),
	delete: (payload) => _client.post("/delete", payload)
};

export default card;